export class BuilderLoginAuditModel {
    Id: number;
    BuilderId: number;
    FirstName: string;
    LastName: string;
    UserName: string;
    CompanyName: string;
    EndDate: string;
    LastAccess: string;
}